import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, AuthContext } from "./contexts/AuthContext"; // Auth context
import Navbar from "./components/Navbar"; // Navbar component
import LoginPage from "./pages/LoginPage"; // Login page
import RegisterPage from "./pages/RegisterPage"; // Registration page
import AdminDashboard from "./pages/AdminDashboard"; // Admin dashboard
import DoctorDashboard from "./pages/DoctorDashboard"; // Doctor dashboard
import PatientDashboard from "./pages/PatientDashboard"; // Patient dashboard
import RadiologistDashboard from "./pages/RadiologistDashboard"; // Radiologist dashboard
import UnauthorizedPage from "./pages/UnauthorizedPage"; // Unauthorized access page
import PrivateRoute from "./components/PrivateRoute"; // Role-based access control
import UserManagement from "./pages/admin/UserManagement"; //  nested route
import ImageManagement from "./pages/common/ImageManagement"; //  nested route
import PatientReportView from "./pages/patient/PatientReport"; //  nested route
import UpdateProfile from "./pages/common/Profile"; //  nested route


// Wrapper to redirect unauthenticated users to login
const AuthenticatedRoute = ({ children }) => {
  const { user } = useContext(AuthContext);
  return user ? children : <Navigate to="/login" replace />;
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Navbar /> {/* Persistent navbar */}
        <Routes>
          <Route path="/" element={<AuthenticatedRoute><Navigate to="/login" /></AuthenticatedRoute>} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/unauthorized" element={<UnauthorizedPage />} />
          <Route path="/Profile" element={<AuthenticatedRoute>{<UpdateProfile />}</AuthenticatedRoute>} />

          {/* Admin Dashboard */}
          <Route path="/admin" element={<PrivateRoute requiredRole="Admin"><AdminDashboard /></PrivateRoute>}>
            <Route path="/admin/user-management" element={<UserManagement />} />
          </Route>

          {/* Doctor Dashboard */}
          <Route path="/doctor" element={<PrivateRoute requiredRole="Doctor"><DoctorDashboard /></PrivateRoute>}>
            <Route path="/doctor/image-management" element={<ImageManagement />} />
          </Route>

          {/* Radiologist Dashboard */}
          <Route path="/radiologist" element={<PrivateRoute requiredRole="Radiologist"><RadiologistDashboard /></PrivateRoute>}>
            <Route path="/radiologist/image-management" element={<ImageManagement />} />
          </Route>

          {/* Patient Dashboard */}
          <Route path="/patient" element={<PrivateRoute requiredRole="Patient"><PatientDashboard /></PrivateRoute>} >
            <Route path="/patient/Patient-Report" element={<PatientReportView />} />
            </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;
